import i18n from 'modules/core/lib/i18n'

import type { Families } from 'modules/billing/store/models/Plan'

const usePlanName = (planFamily: Families | null | undefined): string => {
  switch (planFamily) {
    case 'essentials':
      return i18n.t('pricing_plans.plan_names.essentials')

    case 'premium':
      return i18n.t('pricing_plans.plan_names.premium')

    case 'enterprise':
      return i18n.t('pricing_plans.plan_names.enterprise')

    case 'basic':
    case 'hr':
      return i18n.t('pricing_plans.plan_names.hr')

    case 'legal':
      return i18n.t('pricing_plans.plan_names.legal')

    case 'payroll':
      return i18n.t('pricing_plans.plan_names.payroll')

    case 'free':
      return i18n.t('pricing_plans.plan_names.free')

    default:
      return ''
  }
}

export default usePlanName
